export default {
  methods: {
    validateStatus({
      field,
      serverKey,
      label,
      comparisionField = null,
    }) {
      let validationRules = [];
      validationRules = {
        invalid: field.$invalid,
        dirty: field.$dirty,
        errors: [],
      };

      field.$errors.forEach((error) => {
        // const { type } = error.$params;
        // const type = this.getVuelidateParams(error.$params);
        const params = error.$params;
        validationRules.errors.push({
          type: params.type,
          status: error.$response,
          message: this.getErrorMessage(params, label, params.type, comparisionField),
        });
      });

      if (this.serverValidationErrors[serverKey]) {
        validationRules.errors.push({
          type: 'serverValidation',
          status: false,
          message: this.serverValidationErrors[serverKey],
        });
      }

      return validationRules;
    },
    getErrorMessage(params, formField, type, comparisionField) {
      return this.$lang.formValidation[type](formField, params, comparisionField);
    },
    validateBlur({ field, serverKey }) {
      field.$touch();
      this.serverValidationErrors[serverKey] = null;
    },
  },
};
